export default __webpack_public_path__ + "static/media/applications.f27eda7f.svg";